module.exports = __webpack_public_path__ + "img/faq_icon.152fbe4d.svg";